"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthListenerRemoveButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const constants_1 = require("@dzambalaorg/constants");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const utils_1 = require("../../../utils");
const dialog_1 = require("./dialog");
const dialogs_1 = require("../../../dialogs");
const EthListenerRemoveButton = (props) => {
    const { className, contract, disabled, variant } = props;
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const { fn } = (0, react_hooks_1.useApiCall)(async (api, values) => {
        return api.fetchJson({
            url: "/eth-logger/remove",
            method: "POST",
            data: values,
        });
    });
    const handleEthListenerRemoveConfirm = async ({ data }) => {
        await fn(void 0, data);
    };
    const handleEthListenerRemove = () => {
        openDialog(dialogs_1.GlobalDialogKeys.REMOVE_ETH_LISTENER, contract, {
            initialValues: {
                address: contract.address,
                listenerType: (0, utils_1.getListenerType)(contract),
                chainId: contract.chainId,
            },
            validationSchema: dialog_1.removeEthListenerValidationSchema,
            message: "dialogs.listenerRemove",
            testId: "EthListenerRemoveForm",
            onExternalConfirm: handleEthListenerRemoveConfirm,
        });
    };
    if (process.env.NODE_ENV === constants_1.NodeEnv.production) {
        return null;
    }
    if (contract.contractType === types_1.TokenType.NATIVE) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleEthListenerRemove, icon: icons_material_1.DoNotDisturbOff, message: "form.buttons.removeListener", className: className, dataTestId: "EthListenerRemoveButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract), variant: variant }));
};
exports.EthListenerRemoveButton = EthListenerRemoveButton;
//# sourceMappingURL=index.js.map